import moment from "moment";

const initialState = {
  campaign_no: 1000,
  currentStep: 1,
  steps: [
    {
      id: 1,
      title: "Input Product(s)",
      isVisible: true,
    },
    {
      id: 2,
      title: "Setup Portfolio",
      isVisible: true,
    },
    {
      id: 3,
      title: "Set Budgets & Goals",
      isVisible: true,
    },
    {
      id: 4,
      title: "Set Brand Terms",
      isVisible: false,
    },
    {
      id: 5,
      title: "Add Targets",
      isVisible: false,
    },
    // Session F11: id 6 used to be Sponsored Display's "Upload Logo", then the
    // Sponsored Brands creative. Both live in their own wizards now, so the step
    // is gone. The remaining ids are NOT renumbered — AddCampaign mounts by id
    // and the progress bar numbers by position, so 7 and 8 keep their meaning.
    {
      id: 7,
      title: "Set Bids",
      isVisible: true,
    },
    {
      id: 8,
      title: "Launch",
      isVisible: true,
    },
  ],
  step_1: [],
  step_2: {
    portfolio: null,
    label: `New ${moment(new Date()).format("MM/DD/YYYY")}`,
  },
  step_3: {
    type_1: {
      name: "Sponsored Products - Keyword Targeting",
      isSelected: false,
      namePrefix: "SP-M-KT",
      structureType: "Single ASIN in each Adgroup",
      isSeparateAdgroups: true,
      competitorkeywords: {
        isSelected: true,
        buget: "5",
        targetAcos: "15",
      },
      brandkeywords: {
        isSelected: true,
        buget: "5",
        targetAcos: "15",
      },
      nonBrandkeywords: {
        isSelected: true,
        buget: "5",
        targetAcos: "15",
      },
    },
    type_2: {
      name: "Sponsored Products - Product Targeting",
      isSelected: false,
      namePrefix: "SP-M-PT",
      structureType: "Single ASIN in each Adgroup",
      competitorkeywords: {
        isSelected: true,
        buget: "5",
        targetAcos: "15",
      },
      brandkeywords: {
        isSelected: true,
        buget: "5",
        targetAcos: "15",
      },
    },
    type_3: {
      name: "Sponsored Products - Auto Targeting",
      isSelected: false,
      namePrefix: "SP-A",
      structureType: "Single ASIN in each Adgroup",
      buget: "5",
      targetAcos: "15",
    },
  },
  step_4: {
    isBroad: false,
    isPhrase: true,
    isExact: true,
    brandTerms: "",
  },
  step_5: {
    target_1: {
      isSelected: false,
    },
    target_2: {
      isSelected: false,
      nonBrandkeywords: {
        isBroad: false,
        isPhrase: true,
        isExact: true,
        keywords: "",
      },
      competitorkeywords: {
        isBroad: false,
        isPhrase: true,
        isExact: true,
        keywords: "",
      },
      competitorASINs: "",
    },
  },
  step_7: {
    bidType: "CUSTOM",
    bidValue: "0.25",
    list: [],
    selectedListIds: [],
    targetTypes: [
      {
        isSelected: true,
        type: "KEYWORD_TARGET",
      },
      {
        isSelected: true,
        type: "PRODUCT_TARGET",
      },
      {
        isSelected: true,
        type: "AUTO_TARGET",
      }
    ],
    matchTypes: [
      {
        isSelected: true,
        type: "Exact",
      },
      {
        isSelected: true,
        type: "Phrase",
      },
      {
        isSelected: true,
        type: "Broad",
      }
    ],
    categoryTypes: [
      {
        isSelected: true,
        type: "Competitor",
      },
      {
        isSelected: true,
        type: "Brand",
      },
      {
        isSelected: true,
        type: "Non Brand",
      }
    ],
    campaignTypes: [],
    placementBids: {
      topOfSearch: "0",
      restOfSearch: "0",
      productPages: "0",
    }
  },
};

const addCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GO_TO_NEXT_STEP": {
      const currentStepIndex = state.steps.findIndex(
        (step) => step.id === state.currentStep
      );

      if (currentStepIndex !== -1) {
        for (let i = currentStepIndex + 1; i < state.steps.length; i++) {
          if (state.steps[i].isVisible) {
            return { ...state, currentStep: state.steps[i].id };
          }
        }
      }
      return state;
    }

    case "GO_TO_PREVIOUS_STEP": {
      const currentStepIndex = state.steps.findIndex(
        (step) => step.id === state.currentStep
      );

      if (currentStepIndex !== -1) {
        for (let i = currentStepIndex - 1; i >= 0; i--) {
          if (state.steps[i].isVisible) {
            return { ...state, currentStep: state.steps[i].id };
          }
        }
      }
      return state;
    }

    case "DISPLAY_STEP": {
      return {
        ...state,
        steps: state.steps.map((step) => ({
          ...step,
          isVisible:
            step.id === action.payload.id
              ? action.payload.isVisible
              : step.isVisible,
        })),
      };
    }

    case "SET_STEP":
      return {
        ...state,
        [action.payload.step]: action.payload.data,
      };

    case "UPDATE_STEP3_DATA": {
      const { type, key, value } = action.payload;
      return {
        ...state,
        step_3: {
          ...state.step_3,
          [type]: key
            ? {
                ...state.step_3[type],
                [key]: { ...state.step_3[type][key], ...value },
              }
            : { ...state.step_3[type], ...value },
        },
      };
    }

    case "RESET_ADD_CAMPAIGN_STATE": {
      return initialState;
    }

    default:
      return state;
  }
};

export default addCampaignReducer;
